// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES

import { docodeHexResponse } from '../../_common/common.utils';
import MonthlyWiseInterestSummaryReportAction from './month-wise-interest-summary-report.type';

const INITIAL_STATE = {
	getMonthWiseInterestSummaryReportResp: null,
	getMonthWiseInterestSummaryReportArr: [],

	monthWiseInterestSummaryReportExcelResp: null,
	monthWiseInterestSummaryReportExcelArr: [],
};

const monthWiseInterestSummaryReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** Get Month Wise Interest Summary Report Start ******************/
		case MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_SUCCESS:
			return {
				...state,
				getMonthWiseInterestSummaryReportResp: action.payload,
				getMonthWiseInterestSummaryReportArr: docodeHexResponse(
					action.payload,
					'GetMonthWiseInterestSummaryReportListKey',
				),
			};

		case MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_FAILURE:
			return {
				...state,
				getMonthWiseInterestSummaryReportResp: action.payload,
				getMonthWiseInterestSummaryReportArr: [],
			};

		case MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getMonthWiseInterestSummaryReportResp: null };
		/*************** Get Month Wise Interest Summary Report End ******************/

		/*************** Get Month Wise Interest Summary Report Start ******************/
		case MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_SUCCESS:
			return {
				...state,
				monthWiseInterestSummaryReportExcelResp: action.payload,
				monthWiseInterestSummaryReportExcelArr: docodeHexResponse(
					action.payload,
					'GetMonthWiseInterestSummaryReportExcelListKey',
				),
			};

		case MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_FAILURE:
			return {
				...state,
				monthWiseInterestSummaryReportExcelResp: action.payload,
				monthWiseInterestSummaryReportExcelArr: [],
			};

		case MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_RESPONSE_CHANGED:
			return { ...state, monthWiseInterestSummaryReportExcelResp: null };
		/*************** Get Month Wise Interest Summary Report End ******************/

		default:
			return state;
	}
};
export default monthWiseInterestSummaryReportReducer;
